import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Prompt, useHistory } from 'react-router';
import { useTranslate } from 'react-admin';
import { isBlocking, pathName } from '../../role/actions';
import ContentDialog from './dialog';

function DialogAlertSave({ children, onSave }) {
    const translate = useTranslate();
    const dispatch = useDispatch();
    const history = useHistory();

    let is_blocking = useSelector((state) => state.is_blocking);
    const path_name = useSelector((state) => state.path_name);

    // STATE
    const [open, setOpen] = useState(false);
    // END STATE

    const handleCancelDialog = () => {
        // TODO: Should check this variable to confirm
        is_blocking = false;
        dispatch(isBlocking(is_blocking));
        history.replace(path_name);
    }
    const handleCloseDialog = () => {
        // TODO: Should check this variable to confirm
        setOpen(false)
    }


    const onSaveConfirm = () => {
        is_blocking = false;
        dispatch(isBlocking(is_blocking))
        setOpen(false);
        onSave(() => {
            history.replace(path_name);
        });
    }

    return (
        <Fragment>
            {children}
            <Prompt
                when={is_blocking}
                message={location => {
                    if (is_blocking) {
                        dispatch(pathName(location.pathname))
                        setOpen(true);
                        return false;
                    } else {
                        return true;
                    }
                }}
            />

            <ContentDialog
                confirm={{
                    open,
                    title: translate('resources.role.TitleUnsave'),
                    content: translate('resources.role.ConstTentUnsave'),
                    action: {
                        label: translate('pos.common.save'),
                        onClick: onSaveConfirm,
                        onCancel: handleCancelDialog,
                        onClose: handleCloseDialog,
                    }
                }}
            />
        </Fragment>
    )
}

DialogAlertSave.propTypes = {
    onSave: PropTypes.func.isRequired
};

export default DialogAlertSave;
